/* global axios */
// O validate() PRECISA do axios GLOBAL (window.axios = createAxios(axios)), que
// carrega os headers de auth (DeviseTokenAuth). Importar 'axios' cru aqui mandava
// a requisição SEM auth -> 401 -> o front mostrava o genérico "Não foi possível
// validar a conexão" mesmo com o backend retornando {ok:true}. (Mesmo bug do
// campaigns.js.) get()/create() já usam o global por herança do ApiClient.
import ApiClient from './ApiClient';

// Configurar parceiro SMS Shortcode (cria/valida a inbox da operadora).
// get() -> status (configured/validated/webhook_url); create(data) -> cria/atualiza;
// validate() -> testa a conexão e marca validated.
class SmsPartnerAPI extends ApiClient {
  constructor() {
    super('sms_partner', { accountScoped: true });
  }

  validate() {
    return axios.post(`${this.url}/validate`);
  }
}

export default new SmsPartnerAPI();
